<script setup lang="ts">
import { useRoleLabel } from "@/composable/role-label";
import { Role, ScopeType } from "@soft-db/monitoring-api-client";
import { Button, FormField, Select, SelectOption, Tooltip } from "@soft-db/ui";
import DesktopOnly from "../common/DesktopOnly.vue";
import RoleExplanation from "./RoleExplanation.vue";

defineProps<{
	errors?: string[];
	scope: ScopeType;
	availableRoles: Role[];
	disabled?: boolean;
	disabledReason?: string;
}>();

const role = defineModel<Role>();

const { t } = useI18n();

const helpDialog = ref(false);

const roleLabel = useRoleLabel();
</script>

<template>
	<FormField class="w-full" :label="t('common.role')" :errors="errors">
		<Tooltip :disabled="!disabledReason || !disabled" :tooltip="disabledReason">
			<span>
				<Select v-model="role" class="w-full" :disabled="disabled">
					<SelectOption v-for="r of availableRoles" :key="r" :value="r">
						{{ roleLabel(r) }}
					</SelectOption>
				</Select>
			</span>
		</Tooltip>

		<DesktopOnly>
			<Button
				class="ml-auto w-fit"
				variant="ghost"
				color="primary"
				@click="helpDialog = !helpDialog"
			>
				{{ t("users.roleDefinition") }}
			</Button>
		</DesktopOnly>

		<RoleExplanation v-model:open="helpDialog" :scope="scope" />
	</FormField>
</template>
